/// <amd-module name="SuiteCommerce.Testimonials.Common.InstrumentationHelper"/>
define("SuiteCommerce.Testimonials.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.Testimonials.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QueueNameSuffix = '-Testimonials';
    var ExtensionVersion = '1.0.3';
    var ComponentArea = 'SC Testimonials';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                }
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
